<template>
  <div>

    <div class="row accordion_panel entity_sec" :class="'entity_sec_' + tabIndex">
      <div class="col-12 accordion">

        <div class="accordion_crd">
          <b-card-header header-tag="header" class="row sec_hd" role="tab"  block v-b-toggle="('en_' + category.uuid + tabIndex)" variant="info">
            <div class="col-1 ic_container">
              <div class="ic ic-expand_r"></div>
              <div class="ic ic-collapse_r"></div>
            </div>
            <div class="col-10 hd_txt">
              <div>{{category.title}}</div>
            </div>
          </b-card-header>

          <b-collapse :id="'en_' + category.uuid + tabIndex" visible role="tabpanel" class="row">
            <b-card-body class="accordion_crd_content col-12">

              <div class="row sec_content" v-if="category.courseRequirement">
                <div class="col-12 sec_txt">
                  <div>{{category.courseRequirement}}</div>
                </div>
              </div>

              <div class="row sec_content" v-if="category.description">
                <div class="col-12 sec_txt">
                  <div v-html="category.description"></div>
                </div>
              </div>

              <template v-if="(category.children.length > 0)">
                <template v-if="hasCatalogs">
                  <div class="list_container">
                    <template v-for="(course, i) in category.children">
                      <div class="list_row" v-if="course.entityType ==='catalog'" :key="course.uuid">
                        <div class="title col-12">
                          <div class="thumbnail_sec">
                            <div class="thumbnail" :style="{background: setThumbnailBgColor(course.uuid)}">
                              <div v-html="setThumbnailTitle(course)"></div>
                            </div>
                            <div class="credit_info" v-if="course.creditsEarned">
                              {{course.creditsEarned}}
                            </div>
                          </div>
                          <div>
                            <div class="col_title">
                              <div class="row course_row ace_sec_txt" :class="(((course.entitySubType === 'catalog') && !programGuide.pragyaProgram) ? 'row_clickable' : '')" v-if="(course.entityType === 'catalog')" @click="gotoCatalog(course)">
                                {{course.title}}
                              </div>

                              <div :id="'entityDesc_' + i" v-if="course.description" class="description srt_desc">
                                <span class="desc_txt ace_sec_txt" v-html="course.description"></span>
                              </div>

                               <template>
                                  <div class="lnk_container">
                                    <b-link class="ace_sec_txt" :class="showMoreDescLnk(i)" v-b-modal="'entityDescModal_' + category.uuid + '_' + i">more</b-link>
                                  </div>
                                  <b-modal class="description_modal" size="xl" :id="'entityDescModal_' + category.uuid + '_' + i" :title="course.title" ok-only ok-title="close">

                                    <div class="row">
                                      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                        <div class="desc_txt" v-html="course.description"></div>
                                      </div>
                                    </div>

                                  </b-modal>
                                </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </template>
                <template v-for="subCategory in category.children">
                  <template v-if="(subCategory.entityType ==='category')">
                    <tree-node :key="subCategory.title" :category="subCategory" :tabIndex="(tabIndex+1)"> </tree-node>
                  </template>
                </template>
              </template>

            </b-card-body>
          </b-collapse>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import _ from 'lodash'
  import CourseProgressBar from './CourseProgressBar'
  import { StorageFactory } from '../../../storageFactory'
  import VClamp from 'vue-clamp'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'tree-node',
    props: {category: {
      type: Object,
      required: true
    }, tabIndex:0},
    components: {
      CourseProgressBar,
      VClamp
    },
    data () {
      return {
        userId: localStore.getItem('userid'),
        username: localStore.getItem('userFullName'),
        isCoursesLoaded: false,
        clickedCourse: '',
        selectedStatus: '',
        courseStatusMap: {
          0: 'Not Started',
          1: 'In Progress',
          2: 'Completed',
          7: 'Couldn\'t Complete'
        },
        courseStatusBackgroundMap: {
          0: 'status-not-started',
          1: 'status-in-progress',
          2: 'status-completed',
          7: 'status-not-completed'
        }
      }
    },
    mounted () {
      this.showLoader()
    },
    methods: {
      ...mapActions([
        'loadProgramCourseList',
        'updateProgramCourseStatus',
        'navigateUserToCourseDashboard'
      ]),
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },
      setThumbnailBgColor (uuid) {
        let numValue = uuid.replace(/[^0-9]/g, '')
        return '#' + numValue.slice((numValue.length - 8), (numValue.length - 2))
      },
      setThumbnailTitle (course) {
        if ((course.title.indexOf('-') !== -1) && (course.title.indexOf('-') < 7)) {
          let splitted = course.title.split('-')
          if (splitted.length > 0) {
            return splitted[0]
          }
        }
        return course.title.substring(0, 7)
      },
      async updateCourseStatus (streamId, status) {
        let data = {
          uuid: streamId,
          status: status
        }
        this.updateProgramCourseStatus(data).then(result => {
          this.resetPage()
        })
      },
      openStatusDropDown (course) {
        this.selectedStatus = course.courseStatus
        if (this.clickedCourse) {
          this.closeStatusDropDown(false)
        } else {
          this.clickedCourse = course
          setTimeout(() => {
            this.$refs.courseStatusPopover.$emit('open')
          }, 250)
        }
      },
      closeStatusDropDown (toBeUpdated, status) {
        if (toBeUpdated) {
          this.updateCourseStatus(this.clickedCourse.uuid, status)
        }
        this.clickedCourse = ''
        this.selectedStatus = ''
        this.$refs.courseStatusPopover.$emit('close')
      },
      isStudentLogin () {
        return (localStorage.getItem('userrole') === 'Student')
      },
      gotoCatalog (catalog) {
        if (!this.programGuide.pragyaProgram && (catalog.entitySubType === 'catalog')) {
          let uuid = catalog.uuid
          return this.$router.push({name: 'catalogDetail', params: {uuid: uuid}})
        }
      },
      hasCatalogs () {
        if (this.category.children.length > 0) {
          for (let i = 0; i < this.category.children.length; i++) {
            if (this.category.children[i].entityType === 'catalog') {
              return true
            }
          }
        }
        return false
      },
      showMoreDescLnk (entityDescRowId) {
        let descContainerHeight = $('#entityDesc_' + entityDescRowId + ' .desc_txt').height()
        if (descContainerHeight < 45) {
          return 'hide_more_link'
        } else {
          return 'show_more_link'
        }
      },
      showDesc (fullDesc){
        if(fullDesc){
          let desc = fullDesc.replace( /(<([^>]+)>)/ig, '');
          if(desc.length>101){
            return desc.substring(0,101) + '...'
          }
          return desc;
        }
        return fullDesc
      },
      launchCourse (courseId) {
        let token = localStore.getItem('token')
        this.navigateUserToCourseDashboard({courseId: courseId, token: token}).then(href => {
          window.open(href, '_blank')
        })
      }
    },
    computed: {
      ...mapState({
        'programGuide': state => state.programguide.programGuideObject
      })
    }
  }
</script>

<style>
  .title-txt {
    color: #fff;
    margin-top: 3px;
    font-weight: 500;
    text-align: center;
  }

  div[id^="courseStatusPopup-"] .popover {
    transform: translate3d(-8px, 20px, 0px) !important;
    max-width: 220px !important;
    width: 220px !important;
    height: 225px !important;
    margin-top: 15px;
  }

  div[id^="courseStatusPopup-"] .popover .arrow {
    display: none !important;
  }

  .form-check-input {
    top: 12px;
    cursor: pointer;
  }

  .status-not-started {
    background: #b4b4b4 !important;
  }

  .status-in-progress {
    background: #dd9623 !important;
  }

  .status-completed {
    background: #0a7714 !important;
  }

  .status-not-completed {
    background: #f40909 !important;
  }
  .row_clickable {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/app/transfer/components/TreeNode.vue